import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import OverviewSection from '@/pages/home/components/OverviewSection';
import MobileSection from '@/pages/home/components/MobileSection';
import DesktopSection from '@/pages/home/components/DesktopSection';
import AppSection from '@/pages/home/components/AppSection';
import WatchGuideSection from '@/pages/home/components/WatchGuideSection';
import FilmGuideSection from '@/pages/home/components/FilmGuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import NoticeSection from '@/pages/home/components/NoticeSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <OverviewSection />
        <MobileSection />
        <DesktopSection />
        <AppSection />
        <WatchGuideSection />
        <FilmGuideSection />
        <FaqSection />
        <NoticeSection />
      </main>
      <SiteFooter />
    </div>
  );
}